// extracted by mini-css-extract-plugin
export default {"container":"DrHD2N","bottom":"_VcYUu"};